/**
 * @param {number} value
 * @param {number} total
 * @returns {number}
 */
export function getPercentage(value, total) {
	return (value * total) / 100;
}

/**
 * @param {number} result
 * @param {number} total
 * @returns {number}
 */
export function getPercentageByResult(result, total) {
	return (result * 100) / total;
}

export function randomInt(min, max) {
	return Math.floor(Math.random() * (max - min + 1)) + min;
}
